import { S3BinaryStorage } from "../infrastructure/binary/S3BinaryStorage";
import type { S3BinaryStorageConfig } from "../infrastructure/binary/S3BinaryStorageConfig";

export class S3TriggerBinaryStorageFactory {
  create(config: S3BinaryStorageConfig): S3BinaryStorage {
    return new S3BinaryStorage(config);
  }
}
